import Card from "@/components/Card";
import SectionHeader from "@/components/SectionHeader";
import Stepsbar from "@/components/Stepsbar";
import { Button } from "@/components/ui/button";
import { BiodataSate, DataSiswa, ErrorType, Step, SysBerkas } from "@/types";
import { useEffect, useState } from "react";
// import UnduhBerkas from "./partial/unduh-berkas/UnduhBerkas";
import TimelineDaftarkembali from "@/components/daftarkembali/TimelineDaftarkembali";
import LoaderEGanesha from "@/components/LoaderEGanesha";
import Modal from "@/components/Modal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { CardFooter } from "@/components/ui/card";
import { listPanduanDaftarKembali } from "@/constants";
import useDataPendaftaran from "@/hooks/useDataPendaftaran";
import { useMultistep } from "@/hooks/useMultiStep";
import useScreen from "@/hooks/useScreen";
import useSessionStorage from "@/hooks/useSessionStorage";
import useTimePeriode from "@/hooks/useTimePeriode";
import { useUser } from "@/hooks/useUser";
import api from "@/lib/axios";
import { formatDateIndonesia } from "@/lib/utils";
import {
  getDataStatusIsiUKTPenerimaKIPK,
  getDataStatusValidasiPermanen,
  getDataStep,
  getListBerkas,
} from "@/services/getData";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
  AlertTriangle,
  CalendarDays,
  CheckCircle2,
  ChevronLeft,
  ChevronRight,
  Clock,
  ExternalLink,
  Info,
  Loader2,
  Save,
} from "lucide-react";
import toast from "react-hot-toast";
import { IoWarning } from "react-icons/io5";
import { LuChevronRight } from "react-icons/lu";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import Aset from "./partial/aset/Aset";
import Biodata from "./partial/biodata/Biodata";
import Keluarga from "./partial/keluarga/Keluarga";
import UnggahBerkas from "./partial/unggah-berkas/UnggahBerkas";
import Validasi from "./partial/validasi/Validasi";

const saveBiodata = async (form: FormData, id_sys_periode?: string) => {
  const response = await api.post(
    `/siswa/daftar-kembali/biodata/update${
      id_sys_periode ? `?id_sys_periode=${id_sys_periode}` : ""
    }`,
    form,
    { withCredentials: true },
  );
  return response.data;
};

export default function DaftarKembaliPage() {
  const { user } = useUser();
  const { isMobile } = useScreen();
  const [searchParams] = useSearchParams();
  // const sessionPeriode?.id_sys_periode = searchParams.get("periode");
  const stepParams = searchParams.get("step");
  const navigate = useNavigate();

  const [sessionPeriode] = useSessionStorage("sessionPeriode", {
    id_sys_periode: "",
  });

  const {
    timePassed,
    timePassedActive,
    isLoadingPeriode,
    dataPeriode,
    dataPeriodeActive,
    dataPeriodeCustom,
  } = useTimePeriode();

  const { data: dataStep } = useQuery({
    queryKey: ["dataStep", user?.id, sessionPeriode?.id_sys_periode],
    queryFn: () => getDataStep(sessionPeriode?.id_sys_periode || ""),
    enabled: !!user && !!sessionPeriode?.id_sys_periode,
  });

  const { data: dataBerkas } = useQuery({
    queryKey: ["listDataBerkas", sessionPeriode?.id_sys_periode],
    queryFn: () => getListBerkas(sessionPeriode?.id_sys_periode || ""),
  });

  const { data: dataStatusValidasiPermanen } = useQuery({
    queryKey: ["dataStatusValidasiPermanen", sessionPeriode?.id_sys_periode],
    queryFn: () =>
      getDataStatusValidasiPermanen(sessionPeriode?.id_sys_periode || ""),
    enabled: !!sessionPeriode?.id_sys_periode,
  });

  const {
    data: dataStatusIsiUKTpenerimaKIPK,
    isLoading: isLoadingDataStatusIsiUKTpenerimaKIPK,
    isFetched: isFetchedDataStatusIsiUKTpenerimaKIPK,
  } = useQuery({
    queryKey: ["dataStatusIsiUKTpenerimaKIPK", sessionPeriode?.id_sys_periode],
    queryFn: () =>
      getDataStatusIsiUKTPenerimaKIPK(sessionPeriode?.id_sys_periode || ""),
    enabled: !!sessionPeriode?.id_sys_periode,
  });

  const idDataPendaftaran = dataStep?.id_data_pendaftaran;
  const isValidPermanen =
    dataStatusValidasiPermanen?.is_valid_isi_ukt ||
    timePassedActive.waktu_selesai_isi_ukt_selesai;
  const isWaktuSelesaiIsiUktSelesai =
    timePassedActive.waktu_selesai_isi_ukt_selesai;

  const isValidPermanenTanpaCekTanggal =
    dataStatusValidasiPermanen?.is_valid_isi_ukt;

  const [steps, setSteps] = useState<Step[]>([
    {
      number: 1,
      text: "Biodata",
      link: "#",
      status: "active",
      tabStatus: "active",
    },
    { number: null, text: null, link: null, status: "nonactive" },
    {
      number: 2,
      text: "Keluarga",
      link: "#",
      status: "nonactive",
      tabStatus: "nonactive",
    },
    {
      number: null,
      text: null,
      link: null,
      status: "nonactive",
    },
    {
      number: 3,
      text: "Aset",
      link: "#",
      status: "nonactive",
      tabStatus: "nonactive",
    },
    { number: null, text: null, link: null, status: "nonactive" },
    // {
    //   number: 4,
    //   text: "Unduh Berkas",
    //   link: "#",
    //   status: "nonactive",
    //   tabStatus: "nonactive",
    // },
    // { number: null, text: null, link: null, status: "nonactive" },
    {
      number: 4,
      text: "Berkas",
      link: "#",
      status: "nonactive",
      tabStatus: "nonactive",
    },
    { number: null, text: null, link: null, status: "nonactive" },
    {
      number: 5,
      text: "Validasi",
      link: "#",
      status: "nonactive",
      tabStatus: "nonactive",
    },
  ]);

  // const [visibleCount, setVisibleCount] = useState(5);
  // const handleLoadMore = () => setVisibleCount((prevCount) => prevCount + 5);

  const [listPanduan, setListPanduan] = useState(
    listPanduanDaftarKembali || [],
  );

  const [showPopupPenerimaKIPK, setShowPopupPenerimaKIPK] = useState(false);
  const [showPopupKlarifikasiIsianUkt, setShowPopupKlarifikasiIsianUkt] =
    useState(false);
  const [showPanduan, setShowPanduan] = useState(true);
  const [showFlyer, setShowFlyer] = useState(false);
  const [error, setError] = useState<ErrorType | null>(null);
  const [isPending, setisPending] = useState(false);
  const [isPendingSteps, setisPendingSteps] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [fileBuktiPantiAsuhan, setFileBuktiPantiAsuhan] = useState<File | null>(
    null,
  );
  const [formBiodata, setFormBiodata] = useState<BiodataSate>({
    id_data_siswa: 0,
    id_ref_sekolah: "",
    id_ref_agama: "",
    id_ref_negara: "103",
    id_ref_alat_transportasi: "",
    id_ref_jenis_tinggal: "",
    nama_lengkap: "",
    handphone: "",
    npwp: "",
    tanggal_lahir: "",
    tempat_lahir: "",
    jenis_kelamin: "L",
    berat_badan: 0,
    tinggi_badan: 0,
    ukuran_baju: "",
    jalan: "",
    rt: 0,
    rw: 0,
    kode_pos: "",
    kelurahan: "",
    provinsi: "",
    kabupaten: "",
    kecamatan: "",
    nama_panti_asuhan: "",
    kebutuhan_khusus: [] as string[],
    pilihan_lokasi_kuliah: "singaraja",
    is_anak_tki: undefined,
    is_daerah_bencana: undefined,
    kontak_darurat_hubungan: "",
    kontak_darurat_nama: "",
    kontak_darurat_hp: "",
  });
  const [currentIndexDisable, setCurrentIndexDisable] = useState(2);

  const {
    currentIndex,
    currentStepNumber,
    firstStep,
    lastStep,
    backStep,
    goToStep,
  } = useMultistep(5);

  const [activeAccordion, setActiveAccordion] = useState(
    `item-${currentIndex}`,
  );

  useEffect(() => {
    setActiveAccordion(`item-${currentIndex}`);
  }, [currentIndex]);

  const renderCurrentStep = () => {
    switch (currentIndex) {
      case 0:
        return (
          <Biodata
            form={formBiodata}
            setForm={setFormBiodata}
            error={error}
            file={file}
            setFile={setFile}
            setFileBuktiPantiAsuhan={setFileBuktiPantiAsuhan}
          />
        );
      case 1:
        return (
          <Keluarga
            idDataPendaftaran={idDataPendaftaran}
            isValidPermanen={isValidPermanen}
          />
        );
      case 2:
        return (
          <Aset
            idDataPendaftaran={idDataPendaftaran}
            isValidPermanen={isValidPermanen}
          />
        );
      case 3:
        return (
          <UnggahBerkas
            idDataPendaftaran={idDataPendaftaran}
            isValidPermanen={isValidPermanen}
          />
        );
      case 4:
        return (
          <Validasi
            idDataPendaftaran={idDataPendaftaran}
            isValidPermanen={isValidPermanen}
            isWaktuSelesaiIsiUktSelesai={isWaktuSelesaiIsiUktSelesai}
            isValidPermanenTanpaCekTanggal={isValidPermanenTanpaCekTanggal}
          />
        );
      default:
        return null;
    }
  };

  const queryClient = useQueryClient();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setisPending(true);

    if (firstStep) {
      try {
        const formData = new FormData();

        Object.keys(formBiodata).forEach((key) => {
          const value = formBiodata[key as keyof DataSiswa];
          if (Array.isArray(value)) {
            // Handle array (kebutuhan_khusus)
            value.forEach((item, index) => {
              if (item !== null && item !== undefined) {
                formData.append(`${key}[${index}]`, String(item)); // Konversi ke string menggunakan String()
              }
            });
          } else {
            // Handle nilai non-array
            if (value !== null && value !== undefined) {
              formData.append(key, String(value)); // Konversi ke string menggunakan String()
            }
          }
        });
        if (file) formData.append("foto", file);
        if (fileBuktiPantiAsuhan) {
          formData.append("file_bukti_panti_asuhan", fileBuktiPantiAsuhan);
        }

        const data = await saveBiodata(
          formData,
          sessionPeriode?.id_sys_periode || "",
        );
        queryClient.invalidateQueries({
          queryKey: ["dataSiswaLengkap", user?.id],
        });
        queryClient.invalidateQueries({ queryKey: ["dataStep", user?.id] });
        toast.success(data?.message);

        goToStep(2);
        navigate(`/daftar-kembali?step=2`);
        setError(null);
      } catch (error) {
        const err = error as AxiosError<{ message?: string }>;
        if (err.response?.data) {
          setError(err.response.data as ErrorType);
        } else {
          setError({
            message: "An unknown error occurred.",
            errors: {},
          });
        }
        toast.error(
          err.response?.data?.message || "An unknown error occurred.",
        );
      }
    }

    setisPending(false);
  };

  const handleNextStep = () => {
    switch (currentStepNumber) {
      case 1:
        if (dataStep?.data_diri === 1) {
          goToStep(2);
          navigate(`/daftar-kembali?step=${2}`);
        }
        break;
      case 2:
        if (dataStep?.data_keluarga === 1) {
          goToStep(3);
          navigate(`/daftar-kembali?step=${3}`);
        }
        break;
      case 3:
        if (dataStep?.data_tanah_bangunan === 1) {
          goToStep(4);
          navigate(`/daftar-kembali?step=${4}`);
        }
        break;
      case 4:
        if (dataStep?.data_berkas === 1) {
          goToStep(5);
          navigate(`/daftar-kembali?step=${5}`);
        }
        break;
    }
  };

  // const panduan = listPanduanDaftarKembali[currentIndex];

  useEffect(() => {
    setisPendingSteps(true);

    if (!dataStep) return;

    setSteps((prev) => {
      const updatedSteps = [...prev];

      // Helper function untuk update status connector (null steps)
      const updateConnectorStatus = (index: number) => {
        if (index <= 0 || index >= updatedSteps.length) return;

        const prevStep = updatedSteps[index - 1];
        if (updatedSteps[index].number === null) {
          updatedSteps[index].status =
            prevStep.status === "completed" ? "completed" : "nonactive";
        }
      };

      // Update main steps status
      updatedSteps.forEach((step, index) => {
        if (!step.text) return; // Skip connector steps

        switch (step.text) {
          case "Biodata":
            if (dataStep?.data_diri === 1) {
              step.status = "completed";
              step.tabStatus = "active";
              if (updatedSteps[index + 2]) {
                updatedSteps[index + 2].status = "active";
                updatedSteps[index + 2].tabStatus = "active";
              }
              setCurrentIndexDisable(2);
            }
            break;

          case "Keluarga":
            if (dataStep?.data_keluarga === 1 && dataStep?.data_diri === 1) {
              step.status = "completed";
              step.tabStatus = "active";
              if (updatedSteps[index + 2]) {
                updatedSteps[index + 2].status = "active";
                updatedSteps[index + 2].tabStatus = "active";
              }
              setCurrentIndexDisable(3);
            }
            break;

          case "Aset":
            if (
              dataStep?.data_tanah_bangunan === 1 &&
              dataStep?.data_keluarga === 1 &&
              dataStep?.data_diri === 1
            ) {
              step.status = "completed";
              step.tabStatus = "active";
              if (updatedSteps[index + 2]) {
                updatedSteps[index + 2].status = "active";
                updatedSteps[index + 2].tabStatus = "active";
              }
              setCurrentIndexDisable(4);
            }
            break;

          case "Berkas":
            if (
              dataStep?.data_berkas === 1 &&
              dataStep?.data_tanah_bangunan === 1 &&
              dataStep?.data_keluarga === 1 &&
              dataStep?.data_diri === 1
            ) {
              step.status = "completed";
              step.tabStatus = "active";
              if (updatedSteps[index + 2]) {
                updatedSteps[index + 2].status = "active";
                updatedSteps[index + 2].tabStatus = "active";
              }
              setCurrentIndexDisable(5);
            }
            break;

          case "Validasi":
            if (dataStep?.valid_is_ukt === 1) {
              step.status = "completed";
              step.tabStatus = "active";
              if (updatedSteps[index + 2]) {
                updatedSteps[index + 2].status = "active";
                updatedSteps[index + 2].tabStatus = "active";
              }
            }
            break;
        }
      });

      // Update connector steps
      updatedSteps.forEach((_, index) => {
        updateConnectorStatus(index);
      });

      return updatedSteps;
    });

    // 1. Tentukan batas step maksimum yang boleh diakses user berdasarkan datanya
    let maxAllowedStep = 1;
    if (dataStep?.data_diri === 1) maxAllowedStep = 2;
    if (dataStep?.data_diri === 1 && dataStep?.data_keluarga === 1)
      maxAllowedStep = 3;
    if (
      dataStep?.data_diri === 1 &&
      dataStep?.data_keluarga === 1 &&
      dataStep?.data_tanah_bangunan === 1
    )
      maxAllowedStep = 4;
    if (
      dataStep?.data_diri === 1 &&
      dataStep?.data_keluarga === 1 &&
      dataStep?.data_tanah_bangunan === 1 &&
      dataStep?.data_berkas === 1
    )
      maxAllowedStep = 5;

    if (stepParams) {
      const requestedStep = Number(stepParams);

      // 2. Cegah bypass: Jika step di URL lebih besar dari batas maksimal, paksa gunakan batas maksimal
      const targetStep =
        requestedStep > maxAllowedStep ? maxAllowedStep : requestedStep;

      // 3. Kembalikan URL ke step yang benar jika user mencoba bypass (mencegah bug history browser)
      if (requestedStep !== targetStep) {
        navigate(`/daftar-kembali?step=${targetStep}`, { replace: true });
      }

      setSteps((prev) => {
        return prev.map((step) => {
          if (step.number && step.number === targetStep) {
            return {
              ...step,
              tabStatus: "active",
            };
          }
          return { ...step, tabStatus: "nonactive" };
        });
      });

      // 4. Arahkan sistem komponen multistep ke target yang sudah aman
      goToStep(targetStep);
    }

    setisPendingSteps(false);
  }, [goToStep, dataStep, stepParams, navigate]);

  useEffect(() => {
    setSteps((prev) =>
      prev.map((item) => {
        if (item.number != currentStepNumber)
          return { ...item, tabStatus: "nonactive" };
        return { ...item, tabStatus: "active" };
      }),
    );
  }, [currentStepNumber]);

  useEffect(() => {
    if (isMobile) setShowPanduan(false);
    else if (currentStepNumber == 5) setShowPanduan(false);
    else setShowPanduan(true);
  }, [isMobile, currentStepNumber]);

  const { dataPendaftaran } = useDataPendaftaran();

  useEffect(() => {
    const currentTime = dataPeriode?.waktu_current_server
      ? new Date(dataPeriode.waktu_current_server.replace(" ", "T"))
      : new Date();

    if (timePassed.waktu_pengumuman) {
      // JIKA PENERIMA KIPK DAN BELUM ISI DATA UKT DAN ADA WAKTU CUSTOM WAKTU_SELESAI_ISI_UKT
      // MAKA TETAP DI HALAMAN /DAFTAR-KEMBALI
      if (
        isFetchedDataStatusIsiUKTpenerimaKIPK &&
        dataStatusIsiUKTpenerimaKIPK &&
        dataStatusIsiUKTpenerimaKIPK?.is_penerima_kipk &&
        dataStatusIsiUKTpenerimaKIPK?.is_valid_isi_ukt == 0 &&
        !dataStep?.valid_is_ukt
      ) {
        if (
          dataPeriodeCustom?.custom_waktu_pengumuman_ukt &&
          new Date(
            dataPeriodeCustom.custom_waktu_pengumuman_ukt.replace(" ", "T"),
          ) <= currentTime
        ) {
          navigate("/pengumuman");
        } else {
          setShowPopupPenerimaKIPK(true);
          return;
        }
      } else {
        if (
          dataPeriodeCustom?.custom_waktu_pengumuman_ukt &&
          new Date(
            dataPeriodeCustom.custom_waktu_pengumuman_ukt.replace(" ", "T"),
          ) <= currentTime
        ) {
          navigate(`/pengumuman`);
        } else if (
          dataPendaftaran &&
          dataPendaftaran?.is_klarifikasi_isian_ukt
        ) {
          setShowPopupKlarifikasiIsianUkt(true);
          return;
        } else if (!dataPeriodeCustom) {
          navigate(`/pengumuman`);
        }
      }
    }
  }, [
    timePassed,
    navigate,
    sessionPeriode?.id_sys_periode,
    isFetchedDataStatusIsiUKTpenerimaKIPK,
    dataStatusIsiUKTpenerimaKIPK,
    dataPendaftaran,
    dataPeriode,
    dataPeriodeCustom,
  ]);

  useEffect(() => {
    if (!dataBerkas) return;

    const listNamaBerkas = dataBerkas?.listSysBerkas
      ?.filter((sysBerkas: SysBerkas) => {
        return sysBerkas.jenis_berkas?.slug_jenis_berkas !== "Surat_Pernyataan";
      })
      ?.sort(
        (a: SysBerkas, b: SysBerkas) => Number(b.is_wajib) - Number(a.is_wajib),
      )
      .map((row: SysBerkas) => {
        return `${row.jenis_berkas?.nama_jenis_berkas} ${
          row.is_wajib ? "(*Wajib)" : ""
        }`;
      });

    setListPanduan((prev) =>
      prev?.map((value) => {
        if (value.title.startsWith("Berkas")) {
          return {
            ...value,
            contents: value.contents.map((content) => {
              if (content.title.startsWith("Berkas")) {
                return {
                  ...content,
                  instructions: listNamaBerkas,
                };
              }
              return content;
            }),
          };
        }
        return value;
      }),
    );
  }, [dataBerkas]);

  useEffect(() => {
    if (dataPendaftaran && !dataPendaftaran.is_lulus) {
      navigate("/dashboard", { replace: true });
    }
  }, [dataPendaftaran]);

  if (isLoadingPeriode || isLoadingDataStatusIsiUKTpenerimaKIPK) {
    return <LoaderEGanesha />;
  }

  if (!sessionPeriode?.id_sys_periode || !dataPeriode) {
    return <Navigate to="/dashboard" />;
  }

  const TelegramLink = ({ link }: { link?: string }) => {
    if (!link) return null;
    return (
      <div className="mt-4 p-3 bg-blue-50/50 dark:bg-blue-900/20 rounded-lg border border-blue-100 dark:border-blue-800 flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
        <div className="text-sm text-slate-600 dark:text-slate-300">
          <span className="font-semibold text-blue-700 dark:text-blue-400 block sm:inline mb-1 sm:mb-0">
            Grup Telegram Resmi:
          </span>{" "}
          Wajib menggunakan nama & foto asli.
        </div>
        <Button
          variant="outline"
          size="sm"
          className="text-blue-600 border-blue-200 hover:bg-blue-50 dark:text-blue-400 dark:border-blue-800 dark:hover:bg-blue-900/50 h-8 whitespace-nowrap"
          onClick={() => window.open(link, "_blank")}
        >
          Gabung Sekarang <ExternalLink className="w-3 h-3 ml-2" />
        </Button>
      </div>
    );
  };

  return (
    <main className="relative h-screen">
      <SectionHeader
        title={`Daftar Kembali - ${dataPeriode?.jalur_jenis?.nama_jalur_jenis}`}
      />
      {dataStatusIsiUKTpenerimaKIPK?.is_penerima_kipk &&
      !dataStep?.valid_is_ukt ? (
        <Alert variant={"destructive"} className="mb-3">
          <IoWarning />
          <AlertTitle>
            Perhatian: Anda terdeteksi belum mengisi data UKT hingga tahap
            valid.
          </AlertTitle>
          <AlertDescription>
            <li>
              Jika anda ingin menyelesaikan tahapan daftarkembali, anda wajib
              mengisi data kebutuhan penunjang UKT hingga{" "}
              <span className="text-primary">
                {dataPeriodeActive?.waktu_selesai_isi_ukt &&
                  formatDateIndonesia(dataPeriodeActive?.waktu_selesai_isi_ukt)}
              </span>
            </li>

            <li>
              Pendaftaran kembali diangap selesai jika sudah mendapatkan NIM.
            </li>
          </AlertDescription>
        </Alert>
      ) : (
        ""
      )}
      {timePassedActive?.waktu_selesai_isi_ukt_selesai ? (
        <Alert
          variant="destructive"
          className="mb-6 border-l-4 border-l-red-500 bg-red-50/50 dark:bg-red-950/20 dark:border-red-900"
        >
          <Clock className="h-5 w-5 text-red-600 dark:text-red-400" />
          <AlertTitle className="text-red-700 dark:text-red-400 font-bold flex items-center gap-2">
            Masa Pengisian Berakhir
          </AlertTitle>
          <AlertDescription className="text-slate-600 dark:text-slate-300 mt-2">
            <p className="mb-3">
              Pengisian data penunjang UKT telah ditutup pada{" "}
              <span className="font-semibold text-red-600 dark:text-red-400 bg-red-100 dark:bg-red-900/30 px-1 rounded">
                {dataPeriodeActive?.waktu_selesai_isi_ukt &&
                  formatDateIndonesia(dataPeriodeActive.waktu_selesai_isi_ukt)}
              </span>
              . Anda tidak dapat mengubah data.
            </p>

            <div className="space-y-2 text-sm bg-white/60 dark:bg-black/20 p-3 rounded-md border border-red-100 dark:border-red-900/30">
              <div className="flex gap-2">
                <CalendarDays className="w-4 h-4 text-slate-400 shrink-0 mt-0.5" />
                <span>
                  Pengumuman UKT & KIPK:{" "}
                  <strong>
                    {dataPeriode?.waktu_pengumuman &&
                      formatDateIndonesia(dataPeriode.waktu_pengumuman)}
                  </strong>
                </span>
              </div>
              <div className="flex gap-2">
                <CalendarDays className="w-4 h-4 text-slate-400 shrink-0 mt-0.5" />
                <span>
                  Jadwal Pembayaran:{" "}
                  <strong>
                    {dataPeriode?.waktu_mulai_bayar_ukt &&
                      formatDateIndonesia(dataPeriode.waktu_mulai_bayar_ukt)}
                  </strong>{" "}
                  s/d{" "}
                  <strong>
                    {dataPeriodeActive?.waktu_selesai_bayar_ukt &&
                      formatDateIndonesia(
                        dataPeriodeActive.waktu_selesai_bayar_ukt,
                      )}
                  </strong>
                </span>
              </div>
              <div className="flex gap-2">
                <Info className="w-4 h-4 text-slate-400 shrink-0 mt-0.5" />
                <span>
                  Wajib cetak NIM di sistem setelah pembayaran/penetapan KIPK.
                </span>
              </div>
            </div>

            <TelegramLink link={dataPeriode?.link_telegram} />
          </AlertDescription>
        </Alert>
      ) : isValidPermanenTanpaCekTanggal ? (
        /* KONDISI 2: SUDAH VALIDASI PERMANEN */
        <Alert className="mb-6 border-l-4 border-l-green-500 bg-green-50/50 dark:bg-green-950/20 dark:border-green-900">
          <CheckCircle2 className="h-5 w-5 text-green-600 dark:text-green-400" />
          <AlertTitle className="text-green-700 dark:text-green-400 font-bold">
            Data Terverifikasi Permanen
          </AlertTitle>
          <AlertDescription className="text-slate-600 dark:text-slate-300 mt-2">
            <p className="mb-3">
              Data Anda telah disimpan secara permanen. Mohon menunggu
              pengumuman penetapan UKT & KIPK pada:
            </p>
            <div className="inline-block px-3 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 rounded-full font-semibold text-sm mb-2">
              📅{" "}
              {dataPeriode?.waktu_pengumuman &&
                formatDateIndonesia(dataPeriode.waktu_pengumuman)}
            </div>

            <TelegramLink link={dataPeriode?.link_telegram} />
          </AlertDescription>
        </Alert>
      ) : (
        /* KONDISI 3: WARNING WAJIB ISI (DEFAULT) */
        <Alert className="mb-6 border-l-4 border-l-amber-500 bg-amber-50/50 dark:bg-amber-950/20 dark:border-amber-900">
          <AlertTriangle className="h-5 w-5 text-amber-600 dark:text-amber-400" />
          <AlertTitle className="text-amber-700 dark:text-amber-400 font-bold flex items-center gap-2">
            Segera Lengkapi Data Anda!
          </AlertTitle>
          <AlertDescription className="text-slate-600 dark:text-slate-300 mt-2">
            <div className="flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
              <div className="space-y-1">
                <p>
                  Batas waktu pengisian data hingga valid:{" "}
                  <span className="font-bold text-amber-700 dark:text-amber-400">
                    {dataPeriodeActive?.waktu_selesai_isi_ukt &&
                      formatDateIndonesia(
                        dataPeriodeActive.waktu_selesai_isi_ukt,
                      )}
                  </span>
                </p>
                {!dataStatusIsiUKTpenerimaKIPK?.is_penerima_kipk && (
                  <p className="text-sm text-slate-500 dark:text-slate-400 italic">
                    *Peserta yang tidak memvalidasi data akan dikenakan UKT
                    kelompok tertinggi.
                  </p>
                )}
              </div>
            </div>

            <TelegramLink link={dataPeriode?.link_telegram} />
          </AlertDescription>
        </Alert>
      )}
      <div className="flex lg:flex-col flex-row lg:gap-10">
        <Stepsbar
          steps={steps}
          goToStep={goToStep}
          isPending={isPendingSteps}
        />
        <div className="flex-1">
          <div className="flex lg:flex-row flex-col lg:gap-5 gap-3">
            <div className="flex flex-col gap-3 lg:sticky lg:top-6 h-fit">
              <div className={`${showPanduan ? "lg:w-[20rem]" : ""} h-fit`}>
                <Card>
                  <div className="flex justify-between">
                    {showPanduan && (
                      <h1 className="mb-5 font-bold text-xl">Panduan</h1>
                    )}
                    <div className="flex items-center flex-col gap-y-3">
                      {!showPanduan && (
                        <span className="text-sm font-bold">Panduan</span>
                      )}
                      <Button
                        variant={"outline"}
                        size={"icon"}
                        onClick={() => setShowPanduan((show) => !show)}
                      >
                        <LuChevronRight
                          className={`${
                            showPanduan ? "rotate-90" : "rotate-0"
                          } duration-300`}
                        />
                      </Button>
                    </div>
                  </div>
                  <section className="flex flex-col gap-y-3">
                    {showPanduan && (
                      <Accordion
                        type="single"
                        collapsible
                        value={activeAccordion}
                        onValueChange={setActiveAccordion}
                        className="w-full"
                      >
                        {listPanduan.map((panduan, index) => {
                          // Buat value yang unik untuk setiap item berdasarkan index-nya
                          const itemValue = `item-${index}`;

                          return (
                            <AccordionItem key={index} value={itemValue}>
                              <AccordionTrigger className="text-start">
                                {panduan.title}
                              </AccordionTrigger>
                              <AccordionContent>
                                <div className="flex flex-col gap-4 mt-2">
                                  {panduan.contents.map(
                                    (content, contentIndex) => (
                                      <div key={contentIndex}>
                                        <div className="flex items-center gap-2 mb-1">
                                          <span className="text-primary font-bold">
                                            -
                                          </span>
                                          <h4 className="font-semibold text-slate-800 dark:text-slate-200">
                                            {content.title}
                                          </h4>
                                        </div>
                                        <ul className="pl-4 space-y-1">
                                          {content.instructions.map(
                                            (instruction, indexInstruction) => (
                                              <li
                                                key={indexInstruction}
                                                className="text-muted-foreground text-sm flex gap-2"
                                              >
                                                <span className="font-medium text-slate-500">
                                                  {indexInstruction + 1}.
                                                </span>
                                                <span>{instruction}</span>
                                              </li>
                                            ),
                                          )}
                                        </ul>
                                      </div>
                                    ),
                                  )}
                                </div>
                              </AccordionContent>
                            </AccordionItem>
                          );
                        })}
                      </Accordion>
                    )}
                  </section>
                </Card>
              </div>
              <TimelineDaftarkembali />
            </div>
            <Card className="flex flex-col flex-1 border-slate-200 dark:border-slate-800 shadow-sm">
              <form onSubmit={handleSubmit} className="flex flex-col h-full">
                {/* --- CONTENT AREA --- */}
                <div className="animate-in fade-in slide-in-from-bottom-2 duration-500 flex-1 w-full max-w-full overflow-x-hidden p-1">
                  {renderCurrentStep()}
                </div>

                {/* --- NAVIGATION FOOTER --- */}
                <CardFooter className="py-4 px-6 border-t border-slate-100 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-900/50 flex flex-col-reverse sm:flex-row justify-between gap-3 items-center">
                  {/* Tombol KEMBALI */}
                  <div className="w-full sm:w-auto">
                    {!firstStep && (
                      <Button
                        type="button"
                        variant="ghost"
                        onClick={backStep}
                        className="w-full sm:w-auto text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-100"
                      >
                        <ChevronLeft className="w-4 h-4 mr-2" />
                        Kembali
                      </Button>
                    )}
                  </div>

                  {/* Group Tombol KANAN (Simpan & Berikutnya) */}
                  <div className="flex md:flex-row flex-col gap-3 w-full sm:w-auto">
                    {/* Tombol SIMPAN (Hanya di step awal & belum permanen) */}
                    {firstStep && !isValidPermanen && (
                      <Button
                        type="submit" // Submit form
                        className="w-full sm:w-auto bg-emerald-50 text-emerald-600 hover:bg-emerald-100 border-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-400 dark:border-emerald-800"
                        disabled={
                          isPending || currentIndex === currentIndexDisable - 1
                        }
                      >
                        {isPending ? (
                          <>
                            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                            Menyimpan...
                          </>
                        ) : (
                          <>
                            <Save className="w-4 h-4 mr-2" />
                            Simpan
                          </>
                        )}
                      </Button>
                    )}

                    {/* Tombol BERIKUTNYA */}
                    {!lastStep &&
                      (!firstStep ||
                        (firstStep && dataStep?.data_diri == 1)) && (
                        <Button
                          variant="default"
                          type="button"
                          className="flex-1 sm:flex-none"
                          disabled={
                            isPending ||
                            currentIndex === currentIndexDisable - 1
                          }
                          onClick={handleNextStep}
                        >
                          Berikutnya
                          <ChevronRight className="w-4 h-4 ml-2" />
                        </Button>
                      )}
                  </div>
                </CardFooter>
              </form>
            </Card>
          </div>
        </div>
      </div>

      <Modal
        show={showPopupPenerimaKIPK}
        onClose={() => setShowPopupPenerimaKIPK(false)}
      >
        <div>
          {dataStatusIsiUKTpenerimaKIPK?.is_penerima_kipk ? (
            <Alert
              variant={"default"}
              className="mb-3 border-blue-200 bg-blue-50"
            >
              <IoWarning className="text-blue-600" />
              <AlertTitle className="font-semibold text-blue-800">
                Notifikasi: Status KIP Kuliah & UKT
              </AlertTitle>
              <AlertDescription className="text-blue-900">
                <div className="mt-2 space-y-2">
                  <p>
                    Selamat, Anda terdeteksi{" "}
                    <mark className="bg-yellow-200 px-1 rounded font-bold text-black">
                      eligible
                    </mark>{" "}
                    sebagai penerima KIP Kuliah. Segera lengkapi data UKT hingga
                    dinyatakan valid sebelum{" "}
                    <span className="font-bold text-primary">
                      {dataPeriodeActive?.waktu_selesai_isi_ukt &&
                        formatDateIndonesia(
                          dataPeriodeActive?.waktu_selesai_isi_ukt,
                        )}
                    </span>
                    .
                  </p>
                  <p>
                    Status daftar ulang dinyatakan <strong>selesai</strong>{" "}
                    setelah NIM diterbitkan.
                  </p>
                </div>
              </AlertDescription>
            </Alert>
          ) : (
            ""
          )}
        </div>
      </Modal>

      <Modal
        show={showPopupKlarifikasiIsianUkt}
        onClose={() => setShowPopupKlarifikasiIsianUkt(false)}
      >
        <div>
          <Alert variant={"destructive"} className="mb-3">
            <IoWarning />
            <AlertTitle>Perhatian.</AlertTitle>
            <AlertDescription>
              UKT anda belum dapat ditampilkan, terdapat berkas SLIP Gaji yang
              tidak valid. mohon lakukan perbaikan berkas untuk melakukan
              klarifikasi data dengan benar hingga{" "}
              <span className="font-semibold">
                {dataPeriodeActive?.waktu_selesai_isi_ukt &&
                  formatDateIndonesia(dataPeriodeActive?.waktu_selesai_isi_ukt)}
              </span>
              <p>
                <strong className="text-xl">
                  Setelah melakukan perbaikan wajib buat dan unggah ulang surat
                  pernyataan dan Validasi.
                </strong>
              </p>
            </AlertDescription>
          </Alert>
        </div>
      </Modal>

      <Modal
        className="w-[95vw] sm:w-[32rem] md:w-[40rem] max-w-2xl p-0 overflow-hidden bg-white dark:bg-slate-950"
        show={showFlyer}
        onClose={() => {
          setShowFlyer(false);
        }}
      >
        <div className="flex flex-col max-h-[90vh]">
          {/* Header */}
          <div className="flex justify-between items-center p-4 sm:p-5 border-b border-slate-100 dark:border-slate-800 shrink-0 bg-slate-50 dark:bg-slate-900/50">
            <h3 className="text-xl font-bold text-slate-900 dark:text-white flex items-center gap-2">
              <Info className="w-5 h-5 text-blue-500" />
              Informasi Perubahan Jadwal Daftar Kembali
            </h3>
          </div>

          {/* Body (Scrollable) */}
          <div className="overflow-y-auto p-4 sm:p-6 bg-white dark:bg-slate-950 flex-1 custom-scrollbar">
            <div className="w-full relative overflow-hidden rounded-xl border border-slate-200 dark:border-slate-800 shadow-sm bg-slate-50 dark:bg-slate-900 flex flex-col items-center justify-center min-h-[300px]">
              {/* Image Placeholder */}
              <img
                src="/flyer-snbt.jpeg"
                alt="Flyer Informasi"
                className="w-full h-auto object-contain"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                  const parent = e.currentTarget.parentElement;
                  if (parent) {
                    parent.classList.add("p-10");
                    if (!parent.querySelector(".fallback-text")) {
                      parent.insertAdjacentHTML(
                        "beforeend",
                        '<div class="fallback-text text-center text-slate-400 dark:text-slate-500 flex flex-col items-center gap-3"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/></svg><p class="font-medium">Gambar Flyer Belum Tersedia</p><p class="text-xs"></p></div>',
                      );
                    }
                  }
                }}
              />
            </div>
            <p className="mt-5 text-sm text-slate-600 dark:text-slate-400 leading-relaxed text-center font-medium">
              Silakan perhatikan informasi pada flyer di atas.
            </p>
          </div>

          {/* Footer */}
          <div className="flex-1 p-4 sm:p-5 border-t border-slate-100 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/50">
            <Button
              variant="outline"
              onClick={() => {
                setShowFlyer(false);
              }}
              className="w-full shadow-sm font-semibold"
            >
              Tutup
            </Button>
          </div>
        </div>
      </Modal>
    </main>
  );
}
